export enum ChatbotType {
  AI_AGENT = 'AI_AGENT',
  CLARITY = 'CLARITY'
}
